<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading">
            <div class="row">
                <div class="col-md-12 col-sm-12 ">
                    <div class="">
                        <div class="x_panel">
                            <h2 class="float-left"> Critical Components Report</h2>
                            <ul class="nav navbar-right panel_toolbox">
                                <li v-if="isPermissionExist(PERMISSIONS.CRITICAL_COMPONENTS_REPORT_PRINT)">
                                    <button @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                                        <i class="fa fa-print" v-if="!isPrinting"></i>
                                        <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                                        {{ isPrinting ? 'Printing...' : 'Print' }}
                                    </button>
                                </li>
                              <li v-if="isPermissionExist(PERMISSIONS.CRITICAL_COMPONENTS_REPORT_PRINT)">
                                <vue-excel-xlsx
                                   ref="excel"
                                  :data="excelData"
                                  :columns="excelHeader"
                                  :file-name="'Critical Components Report'"
                                  :file-type="'xlsx'"
                                  :sheet-name="'sheetname'"
                                  :disabled="isPrinting"
                                  class="btn btn-primary btn-sm float-right"
                                >
                                  <div
                                    @click.prevent="handleExportPrint('excel')"
                                  >
                                    <i class="fa fa-file-excel-o"></i>
                                    {{ isPrinting ? 'Preparing...' : 'Excel' }}
                                  </div>
                                </vue-excel-xlsx>
                              </li>
                                <li>
                                    <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                                </li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Department</label>
                                                    <select v-model="departmentId" name="department_id" class="form-control" @change="mainComponent(departmentId)">
                                                        <option value selected>Select Department</option>
                                                        <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Main Component</label>
                                                    <select v-model="mainComponentId" name="main_component_id" class="form-control" @change="Component(mainComponentId)">
                                                        <option value selected>Select Main Component</option>
                                                        <option v-for="mainComponent in mainComponents" :key="mainComponent.id" :value="mainComponent.id">{{ mainComponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Component</label>
                                                    <select v-model="componentId" name="component_id" class="form-control" @change="subComponent(componentId)">
                                                        <option value selected>Select component</option>
                                                        <option v-for="component in components" :key="component.id" :value="component.id">{{ component.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Sub Component</label>
                                                    <select v-model="subComponentId" name="component_id" class="form-control" @change="getSubSubComponent(subComponentId)">
                                                        <option value="" selected>Select Sub component</option>
                                                        <option v-for="subcomponent in subcomponents" :key="subcomponent.id" :value="subcomponent.id">{{ subcomponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label>Sub Sub Component </label>
                                                    <select v-model="subSubComponentId" name="component_id" class="form-control">
                                                        <option value="" selected>Select Sub Sub component</option>
                                                        <option v-for="subsubcomponent in subsubcomponents" :key="subsubcomponent.id" :value="subsubcomponent.id">{{ subsubcomponent.name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2 col-6 ">
                                                <div class="form-group">
                                                    <label for="">Search </label>
                                                    <input type="text" placeholder="Enter component name or code" v-model="searchInput" name="searchInput" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-1 mt-2">
                                                <div class="form-group">
                                                    <label for=""></label>
                                                    <button class=" mt-3 btn-info btn btn-sm" @click="getData()">Search</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <label>Showing:</label>
                                            <select class="form-select mx-2" style="width:120px" v-model="offset" @change="getData">
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <label>entries</label>
                                        </div>

                                        <div class="card-box table-responsive">
                                            <p class="text-muted font-13 m-b-30"></p>
                                            <table :class="getTableClasses" style="width:100%">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Department Name</th>
                                                    <th>Main Component Name</th>
                                                    <th>Component Name</th>
                                                    <th>Sub Component Name</th>
                                                    <th>Sub Sub Component Name</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(component , index) in criticalComponenetList?.data" :key="index">
                                                    <td>{{ (criticalComponenetList?.current_page - 1) * criticalComponenetList?.per_page + index + 1 }}</td>
                                                    <td>{{component?.department}}</td>
                                                    <td>{{component?.main_component}}</td>
                                                    <td>{{component?.component}}</td>
                                                    <td>{{component?.sub_component}}</td>
                                                    <td>{{component?.sub_sub_component}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <Pagination :pagination="criticalComponenetList" :getData="getData"/>

                                            <div id="printArea" style="display: none">
                                                <div style="text-align: center;line-height: 20px;">
                                                    <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                    <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                                                    <div style="line-height: 10px;" class="font-weight-bold">Critical Component List</div>
                                                    <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                                    <table :class="getTableClasses" style="width:100%">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Department Name</th>
                                                            <th> Main Component Name</th>
                                                            <th> Component Name</th>
                                                            <th> Sub Component Name</th>
                                                            <th>Sub Sub Component Name</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(component , index) in printItems" :key="index">
                                                            <td>{{index + 1 }}</td>
                                                            <td>{{component?.department}}</td>
                                                            <td>{{component?.main_component}}</td>
                                                            <td>{{component?.component}}</td>
                                                            <td>{{component?.sub_component}}</td>
                                                            <td>{{component?.sub_sub_component}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '@/auth.js'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";
    import permissionsMixin from "@/mixin/permissionsMixin";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";

    export default {
        name: 'sub_sub_component',
        components: {Pagination, PulseLoader},
        mixins: [permissionsMixin, printMixin, goBackButtonMixin],
        data() {
            return {
                loading: false,
                editMode: false,
                isPrinting: false,
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                printItems: [],
                query: '',
                queryFiled: 'name',
                departments: [],
                mainComponents: [],
                components: [],
                subcomponents: [],
                subsubcomponents: [],
                criticalComponenetList: [],
                budgetHeads: [],
                component_id: '',
                departmentId: '',
                mainComponentId: '',
                componentId: '',
                subComponentId: '',
                subSubComponentId: '',
                searchInput: '',
                offset: 20,
                form: new Form({
                    id: '',
                    name: '',
                    code: '',
                    department_id: '',
                    main_component_id: '',
                    parent_id: '',
                    budget_head_id: '',
                    type: 'sub-sub-component',
                    critical_equipment: '',
                    vessel_id: auth.getVesselId(),
                    status: 'Activate'
                }),
                showInfo: {
                    mainComponentName: '',
                    ComponentName: '',
                    subComponentName: ''
                },
                pagination: {
                    current_page: 1
                },
                permissions: auth.getPermissionData(),
                vessel_id: auth.getVesselId(),
            }
        },
        mounted() {
            this.departmentList();
            this.getData()
        },
        computed: {
            getTableClasses() {
                return {
                    'table': true,
                    'text-center': true,
                    'table-striped': !this.isPrinting,
                    'table-bordered': !this.isPrinting,
                    'table-sm': !this.isPrinting,
                    'print-table': this.isPrinting,
                    'vertical-align-middle': true
                };
            }
        },
        methods: {
            getData(page = 1) {
                this.loading = true;
                var params = {
                    page: page,
                    is_all: 0,
                    department_id: this.departmentId,
                    main_component_id: this.mainComponentId,
                    component_id: this.componentId,
                    sub_component_id: this.subComponentId,
                    sub_sub_component_id: this.subSubComponentId,
                    search: this.searchInput,
                    offset: this.offset,
                    vessel_id: this.vessel_id,
                };
                this.$http.get('/api/report/critical-component', {params}).then(response => {
                    this.criticalComponenetList = response.data.success;
                    this.loading = false
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Department Name': `${item?.department || ''}`,
                'Main Component Name': `${item?.main_component || ''}`,
                'Component Name': `${item?.component || ''}`,
                'Sub Component Name': `${item?.sub_component || ''}`,
                'Sub Sub Component Name': `${item?.sub_sub_component || ''}`,
              });
            });
            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                is_all: 1,
                department_id: this.departmentId,
                main_component_id: this.mainComponentId,
                component_id: this.componentId,
                sub_component_id: this.subComponentId,
                sub_sub_component_id: this.subSubComponentId,
                search: this.searchInput,
                vessel_id: this.vessel_id,
              };

              const res = await this.$http.get('/api/report/critical-component', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Critical Components Report');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            departmentList() {
                this.mainComponents = []
                this.components = []
                this.mainComponentId = ''
                this.componentId = ''
                var params = {
                    is_all: 1,
                }
                this.$http.get('/api/filter/department/' + this.vessel_id, {params}).then(response => {
                    this.departments = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            mainComponent(departmentId = null) {
                this.mainComponents = []
                this.components = []
                this.subcomponents = []
                this.componentId = ''
                var params = {
                    is_all: 1,
                }
                if (departmentId) {
                    this.form.department_id = departmentId
                }

                if (this.form.department_id != '') {
                    this.$http.get('/api/filter/main-component/' + this.vessel_id + '/' + this.form.department_id, {params}).then(response => {
                        this.mainComponents = response.data.success
                    }).catch(e => {
                        console.log(e)
                    })

                } else {
                    this.mainComponents = []
                }
            },
            Component(mainComponentId = null) {
                this.subComponentId = ''
                var params = {
                    is_all: 1,
                }
                if (mainComponentId) {
                    this.form.main_component_id = mainComponentId
                }
                if (this.form.main_component_id != '') {
                    this.$http.get('/api/filter/component/' + this.vessel_id + '/' + this.form.main_component_id, {params}).then(response => {
                        this.components = []
                        this.components = response.data.success
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    this.components = []
                }
            },
            subComponent(subComponentId = null) {
                var params = {
                    is_all: 1,
                }
                if (subComponentId) {
                    this.component_id = subComponentId;
                }
                if (this.component_id != '') {
                    this.$http.get('/api/filter/sub-component/' + this.vessel_id + '/' + this.component_id, {params}).then(response => {
                        this.subcomponents = []
                        this.subcomponents = response.data.success
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    this.subcomponents = []
                }
            },
            getSubSubComponent(sub_component_id) {
                this.subsubcomponents = [];
                this.subSubComponentId = '';
                let params = {
                    is_all: 1
                }
                if (sub_component_id != '0') {
                    this.$http.get('/api/filter/sub-sub-component/' + this.vessel_id + '/' + sub_component_id, {params}).then((response) => {
                        this.subsubcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>

<style scoped>

</style>
